<template>
  <nav class="dash-breadcrumbs" aria-label="Breadcrumb" data-testid="dashboard-breadcrumbs">
    <template v-for="(item, index) in items" :key="index">
      <router-link v-if="item.to && index < items.length - 1" :to="item.to" class="dash-breadcrumbs__crumb">
        {{ item.label }}
      </router-link>
      <span v-else class="dash-breadcrumbs__crumb dash-breadcrumbs__crumb--current" aria-current="page">
        {{ item.label }}
      </span>
      <v-icon
        v-if="index < items.length - 1"
        :icon="mdiChevronRight"
        size="16"
        class="dash-breadcrumbs__sep"
        aria-hidden="true"
      />
    </template>
  </nav>
</template>

<script setup lang="ts">
import { mdiChevronRight } from "@mdi/js";
import type { RouteLocationRaw } from "vue-router";

export interface DashboardBreadcrumbItem {
  label: string;
  to?: RouteLocationRaw;
}

defineProps<{
  items: DashboardBreadcrumbItem[];
}>();
</script>

<style scoped>
.dash-breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 4px;
  margin-bottom: 8px;
  font-size: 0.85rem;
}

.dash-breadcrumbs__crumb {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  color: rgb(var(--v-theme-primary-darken-1));
  text-decoration: none;
  font-weight: 600;
  transition:
    background-color 0.12s ease,
    color 0.12s ease;
}

.dash-breadcrumbs__crumb:hover {
  background-color: color-mix(in srgb, rgb(var(--v-theme-primary)) 8%, transparent);
}

.dash-breadcrumbs__crumb--current {
  color: var(--th-color-text-strong);
  cursor: default;
}

.dash-breadcrumbs__crumb--current:hover {
  background-color: transparent;
}

.dash-breadcrumbs__sep {
  color: rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
}
</style>
